import React from 'react';
import { Button } from '@economic/gaudi';

import ExternalLink from '../../shared/components/ExternalLink';
import { t, tBB } from '../../shared/components/l10n/l10n';
import iconLearn from './iconLearn.svg';
import iconLightbulb from './iconLightbulb.svg';
import iconRead from './iconRead.svg';
import success from './onboarding_getstarted.png';

interface Props {
    onDone: () => void;
}

export default function StepSuccess({ onDone }: Props) {
    return (
        <div className="onboarding__container__fixed-size">
            <div className="onboarding onboarding__success">
                <img src={success} alt="" className="onboarding__picture" />

                <h2>{t`ONBOARDING_GETTINGSTARTED_SUCCESS_TITLE`}</h2>

                <p>{t`ONBOARDING_GETTINGSTARTED_SUCCESS_CONTENT`}</p>

                <Button appearance="primary" onClick={onDone}>{t`ONBOARDING_GETTINGSTARTED_SUCCESS_CTA`}</Button>

                <div className="bottom-panel">
                    <div>
                        <img src={iconRead} alt="" className="mx-auto" />
                        <p>
                            {tBB(`ONBOARDING_GETTINGSTARTED_SUCCESS_TIP1`, {
                                __LINK: content => (
                                    <ExternalLink href="https://www.e-conomic.dk/support/e-copedia">{content}</ExternalLink>
                                ),
                            })}
                        </p>
                    </div>
                    <div>
                        <img src={iconLightbulb} alt="" className="mx-auto" />
                        <p>
                            {tBB('ONBOARDING_GETTINGSTARTED_SUCCESS_TIP2', {
                                __LINK: content => (
                                    <ExternalLink href="https://www.e-conomic.dk/support/kom-godt-i-gang">{content}</ExternalLink>
                                ),
                            })}
                        </p>
                    </div>
                    <div>
                        <img src={iconLearn} alt="" className="mx-auto" />
                        <p>
                            {tBB(`ONBOARDING_GETTINGSTARTED_SUCCESS_TIP3`, {
                                __LINK: content => (
                                    <ExternalLink href="https://www.e-conomic.dk/support/online-kurser">{content}</ExternalLink>
                                ),
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
